import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Reviews from './Reviews';
import Footer from 'src/components/Footer';
import SmallHeader from '../Van/singleVanPage/SmallHeader';
import MainHostInfo from '../Van/components/Modal/HostModal/components/MainInfo';
import ExtrasHost from '../Van/components/Modal/HostModal/components/Extras';
import Map from 'src/pages/Van/singleVanPage/Map';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';
import './media.scss';

const HostPage: FC = () => {
  const { getHost, getLocations, setStartDateFilter, setEndDateFilter, setupFilters } =
    useActions();
  const { id } = useParams();
  // const container = document.getElementsByClassName('host-page__vans')[0];
  const host = useTypedSelector(state => state.host.host);
  const isLoadingGetHost = useTypedSelector(state => state.host.isLoading.get);
  // const { vanList, checkFilter, filters, errors, isFilterValidate, isLoading } = useTypedSelector(
  //   state => state.van
  // );

  useEffect(() => {
    if (id) {
      getHost(id);
      // getLocations();
      // setupFilters({
      //   ...initFilter,
      //   tags: [id.toUpperCase()]
      // });
    }
  }, [id]);

  return (
    <>
      <div className='host-page__filling' />
      <div className='header'>
        <SmallHeader isLogout={false} />
      </div>
      <div className='host-page'>
        {isLoadingGetHost ? (
          <div className='host-page__loading'>
            <CircularProgress size={100} />
          </div>
        ) : (
          host && (
            <div className='host-page__wrapper'>
              <div className='host-page__top'>
                <MainHostInfo host={host} />
                <div className='hostModal__top__description'>
                  <h4>Hi, I am {host.first_name}</h4>
                  <h6>Thanks for considering us for your next Sprinter Van Rental!</h6>
                  <p>{host.description}</p>
                  <div className='host-page__top__info'>
                    <ExtrasHost />
                  </div>
                </div>
              </div>
              {host.feedback.length ? <Reviews host={host} /> : <></>}
              <Map address={host.city} />
              {/* <div className='host-page__vans'>
              <p className='host-page__vans__title'>{host.first_name}'s Vehicles</p>
              <div className='host-page__vans__search'>
                <div className='singleVan__availability__formContainer__locations'>
                  <Filters.Location check={checkFilter} className={'location'} />
                  <Filters.AnotherLocation check={checkFilter} className={'location'} />
                </div>
                <Filters.Times
                  className={'singleVan__availability__formContainer__times'}
                  check={checkFilter}
                  startDate={filters.start_date}
                  endDate={filters.end_date}
                  handleStartDate={setStartDateFilter}
                  handleEndDate={setEndDateFilter}
                />
                <Button
                  onClick={() => setupFilters(filters)}
                  variant='contained'
                  className='host-page__vans__search__button'
                >
                  {isLoading.all ? <CircularProgress size={16} /> : 'GET VANS'}
                </Button>
              </div>
              {Object.keys(vanList).length ? (
                <div className='host-page__vans__list'>
                  {Object.keys(vanList).map(location =>
                    vanList[location].map(van => (
                      <VanCard
                        van={van}
                        key={van.id}
                        errors={errors}
                        isFilterValidate={isFilterValidate}
                        container={container}
                      />
                    ))
                  )}
                </div>
              ) : (
                <div className='host-page__vans__loading'>
                  <CircularProgress size={100} />
                </div>
              )}
            </div> */}
            </div>
          )
        )}
      </div>
      <Footer />
    </>
  );
};
export default HostPage;
